import React from "react";
import Pageone, { Pageonec } from "./Pageone"; // 1
import ItemList, { ItemListc } from "./ItemList"; // 2
import ItemDescriptions, { ItemDescriptionsc } from "./ItemDescriptions";
 import CartList, { CartListc } from "./CartList";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Contactus from '../src/footer/Contactus'
/*
import Media from '../src/footer/Media'
import Faqs from '../src/footer/Faqs'
import About from '../src/footer/About'
import Community from '../src/footer/Community'
*/
import Investors from '../src/footer/Investors'
import Appbar, { Appbarc } from "./Appbar";
import Footer from "./Footer";
import { Box } from "@mui/material";
import Login from "./Login";
import Registration from "./Registration";
import FinalOrder, { FinalOrderc } from "./FinalOrder";
import OrderList from "./OrderList";
import WishList, { WishListc } from "./WishList";
import Become_sellers from "./Become_sellers";
/*
import Career from "./footer/Career";
import Privacy from '../src/footer/Privacy'

import StoreList from "./StoreList";



import RefundPolicy from "./RefundPolicy";
import Terms_and_conditon from "./footer/Terms_and_conditon";
*/

const router = createBrowserRouter([
  {
    path: "/",
    element:<Pageonec/>
  },
  {
    path: "/itemList",
    element: <ItemListc/>,
  },
  {
    path: "/itemDescription/:id",
    element: <ItemDescriptionsc/>,
  },

{
  path: "/login",
  element: <Login/>,
},
{
  path: "/register",
  element: <Registration/>,
},

{
  path: "/contact",
  element: <Contactus/>,
},

  {
    path: "/cartList",
    element: <CartListc/>,
  },

  {
  path: "/finalorders",
  element: <FinalOrderc/>,
},

{
  path: "/orderList",
  element: <OrderList/>,
},
{
  path: "/wishList",
  element: <WishListc/>,
},
{
  path: "/sellers",
  element: <Become_sellers/>,
},
  /*


/////// footer section router ///////////
{
  path: "/career",
  element: <Career/>,
},

{
  path: "/media",
  element: <Media/>,
},
{
  path: "/faq",
  element: <Faqs/>,
},
{
  path: "/about",
  element: <About/>,
},
{
  path: "/community",
  element: <Community/>,
},
{
  path: "/investors",
  element: <Investors/>,
},
{
  path: "/privacy",
  element: <Privacy/>,
},
{
  path: "/refundPolicy",
  element: <RefundPolicy/>,
},
{
  path: "/termsAndCondition",
  element: <Terms_and_conditon/>,
},



////// authentication ////////////

{
  path: "/store",
  element: <StoreList/>,
},


{
  path: "/wishList",
  element: <WishListc/>,
},






*/


]);


function App() {
  return (
 <Box>
<Appbar/>
     <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
  <Footer/>
 </Box>
 


  );
}

export default App;
